// Info Modal functionality using simple divs instead of custom elements
(function() {
  console.log('Info modal script loaded');

  function initInfoModals() {
    console.log('Initializing info modals...');
    
    setTimeout(() => {
      const triggers = document.querySelectorAll('.info-modal-trigger');
      const modals = document.querySelectorAll('[data-modal-component]');
      
      console.log('Found triggers:', triggers.length);
      console.log('Found modals:', modals.length);
      
      // Setup triggers
      triggers.forEach(trigger => {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          const modalId = this.getAttribute('data-modal-target');
          console.log('Button clicked! Looking for modal:', modalId);
          
          const modal = document.getElementById(modalId);
          console.log('Found modal element:', modal);
          
          if (modal) {
            openModal(modal);
          } else {
            console.error('Modal not found with ID:', modalId);
          }
        });
      });
      
      // Setup close buttons for all modals
      modals.forEach(modal => {
        const closeButtons = modal.querySelectorAll('[data-modal-close]');
        console.log('Found close buttons for modal:', closeButtons.length);
        
        closeButtons.forEach(btn => {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('Close button clicked!');
            closeModal(modal);
          });
        });
      });
      
      // Close on Escape key
      document.addEventListener('keyup', function(e) {
        if (e.key === 'Escape') {
          modals.forEach(modal => {
            if (modal.classList.contains('is-open')) {
              closeModal(modal);
            }
          });
        }
      });
      
    }, 100);
  }
  
  function openModal(modal) {
    console.log('Opening modal...');
    modal.style.display = 'block';
    // Small delay to ensure display:block is applied before adding is-open class
    setTimeout(() => {
      modal.classList.add('is-open');
    }, 10);
    document.body.style.overflow = 'hidden';
    console.log('Modal opened! Classes:', modal.classList.toString());
  }
  
  function closeModal(modal) {
    console.log('Closing modal...');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    
    // Wait for animation to finish before hiding
    setTimeout(() => {
      if (!modal.classList.contains('is-open')) {
        modal.style.display = 'none';
      }
    }, 300); // Match the CSS transition duration (0.3s = 300ms)
  }
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfoModals);
  } else {
    initInfoModals();
  }
})();